module.exports = __webpack_public_path__ + "img/loading.bcde7d06.gif";